import {ErrorHandler, Injectable} from '@angular/core';
import {environment} from '@env/environment';
import * as Sentry from '@sentry/browser';
import packageJson from '../../package.json';
import * as SentryIntegrations from '@sentry/integrations';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
	constructor() {
		if (environment.production) {
			Sentry.init({
				dsn: 'https://ef969ac4382c4bb5a5b8cff4dca05661@o266169.ingest.sentry.io/6019500',
				environment: environment.production ? 'production' : 'dev',
				release: environment.prefixSentry + '.' + packageJson.version,
				integrations: [new SentryIntegrations.Dedupe()],
			});
		}
	}

	public handleError(err: any): void {
		if (!environment.production) {
			console.error(err);

			return;
		}

		const chunkFailedMessage = /Loading chunk [\d]+ failed/;
		const isFailedChunkLoadingError = chunkFailedMessage.test(err.message);
		if (isFailedChunkLoadingError) {
			window.location.reload();

			return;
		}

		if (!navigator.onLine) {
			const noInternetHandler = () => {
				if (navigator.onLine) {
					window.removeEventListener('online', noInternetHandler);
					window.location.reload();
				}
			};

			window.addEventListener('online', noInternetHandler);

			return;
		}

		Sentry.captureException(err.originalError || err);
	}
}
